import React, {Fragment, Suspense} from 'react';
import MasterLayout from "../../components/MasterLayout/MasterLayout";
import LazyLoader from "../../components/MasterLayout/LazyLoader";
import DiscountProductList from '../../components/Discount/DiscountProductList';
const DiscountProductListPage = () => {
    return (
        <Fragment>
            <MasterLayout>
                <Suspense fallback={<LazyLoader/>}>
                    <DiscountProductList/>
                </Suspense>
            </MasterLayout>
        </Fragment>
    );
};
export default DiscountProductListPage;